import React from "react";
import { useMedia } from "react-use";
import { config as cssConfig } from "@100mslive/roomkit-react";

const SixCareersPosition = () => {
  const isMobile = useMedia(cssConfig.media.sm);
  return (
    <section className="events-page-landing-section events-page-landing-section-space events-page-careers-section-at">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-careers-section-header text-center">
          <div className="events-page-careers-section-header-heading">
            Open Positions
          </div>
          <div className="events-page-careers-section-header-text">
            In our fast-paced, innovative environment, you'll have the
            opportunity to work across teams, gaining{" "}
            {!isMobile ? <br /> : null} exposure to all aspects of our platform.
          </div>
        </div>
      </div>
    </section>
  );
};

export default SixCareersPosition;
